import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Button from "components/CustomButtons/Button.js";
import Close from "@material-ui/icons/Close";
import classNames from "classnames";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";

const useStyles3 = makeStyles(javascriptStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

const MessageDialog = ({
	messageData,
	setMessageData,
	showMessageDialog,
	setShowMessageDialog,
}) => {
	const classes3 = useStyles3();

	return (
		<Dialog
			classes={{
				root: classes3.modalRoot,
				paper: classes3.modalSmall,
			}}
			open={showMessageDialog}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => setShowMessageDialog(false)}
			aria-labelledby="classic-modal-slide-title"
			aria-describedby="classic-modal-slide-description">
			<DialogTitle
				id="classic-modal-slide-title"
				disableTypography
				className={classNames(classes3.container, classes3.modalHeader)}>
				<Button
					simple
					className={classes3.modalCloseButton}
					key="close"
					aria-label="Close"
					onClick={() => setShowMessageDialog(false)}>
					{" "}
					<Close className={classes3.modalClose} />
				</Button>
				<h4 className={classNames(classes3.modalTitle)}>{messageData?.title}</h4>
			</DialogTitle>
			<DialogContent
				id="classic-modal-slide-description"
				className={classes3.modalBody}>
				{messageData?.message}
			</DialogContent>
			<DialogActions className={classes3.modalFooter}>
				<Button
					color="danger"
					onClick={() => {
						setShowMessageDialog(false);
						setMessageData(null);
					}}>
					close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default MessageDialog;
